import { Select, Space } from "antd";
import React, { useContext, useEffect, useState } from "react";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import { toast } from "react-toastify";
import {
  useGetAllTeamsQuery,
  useEditTeamMutation,
} from "../../../Redux/service/Teams/Teams";
import { useGetSpecificUserQuery } from "../../../Redux/service/Users/Users";

export default function AssignTeamPopup({ setEdited }) {
  const { isAssigningTeam, setIsAssigningTeam, activeUserForTeam } =
    useContext(popupcontext);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [teams, setTeams] = useState([]);

  // Fetch all teams
  const { data: allTeamsData, refetch: refetchTeams } = useGetAllTeamsQuery(
    {
      page: 1,
      limit: 10000,
      search: "",
      status: "ACTIVE",
    },
    { refetchOnMountOrArgChange: true },
  );

  // Fetch user details
  const { data: userData } = useGetSpecificUserQuery(activeUserForTeam?.id, {
    skip: !activeUserForTeam?.id,
  });

  const [editTeam] = useEditTeamMutation();

  const handleDropdownVisibleChange = (visible) => {
    if (visible) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  // Get teams that the user is already assigned to
  useEffect(() => {
    if (allTeamsData?.data && activeUserForTeam?.id) {
      const userTeams = allTeamsData.data.filter((team) =>
        team.memberUserIds?.includes(activeUserForTeam.id),
      );
      setSelectedTeams(userTeams.map((team) => team.id));
    }
  }, [allTeamsData?.data, activeUserForTeam?.id]);

  // Set team options
  useEffect(() => {
    if (allTeamsData?.data) {
      setTeams(
        allTeamsData.data.map((team) => ({
          value: team.id,
          label: `${team.name} (${team.code})`,
        })),
      );
    }
  }, [allTeamsData?.data]);

  const handleAssign = async (teamId) => {
    try {
      // Fetch the team details
      const teamResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/companies/teams/${teamId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      const teamData = await teamResponse.json();

      // Add user to team's memberUserIds
      const currentMemberIds = teamData?.data?.memberUserIds || [];
      if (!currentMemberIds.includes(activeUserForTeam.id)) {
        const updatedMemberIds = [...currentMemberIds, activeUserForTeam.id];

        // Prepare FormData for team update
        const formData = new FormData();
        Object.keys(teamData.data).forEach((key) => {
          if (key === "memberUserIds") {
            updatedMemberIds.forEach((userId) => {
              formData.append("memberUserIds", userId);
            });
          } else if (key === "trades" && Array.isArray(teamData.data[key])) {
            teamData.data[key].forEach((trade) => {
              formData.append("trades", trade);
            });
          } else if (
            key === "assignedZones" &&
            Array.isArray(teamData.data[key])
          ) {
            teamData.data[key].forEach((zone) => {
              formData.append("assignedZones", zone);
            });
          } else if (
            teamData.data[key] !== null &&
            teamData.data[key] !== undefined &&
            teamData.data[key] !== ""
          ) {
            formData.append(key, teamData.data[key]);
          }
        });

        await editTeam({ id: teamId, payload: formData }).unwrap();
        toast.success(trans("User assigned to team successfully"), {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar",
        });
        await refetchTeams();
      }
    } catch (error) {
      setSelectedTeams((prev) => prev.filter((v) => v !== teamId));
      toast.error(
        error?.data?.message || trans("Failed to assign user to team"),
        {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar" ? true : false,
        },
      );
    }
  };

  const handleUnAssign = async (teamId) => {
    try {
      // Fetch the team details
      const teamResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/companies/teams/${teamId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      const teamData = await teamResponse.json();

      // Remove user from team's memberUserIds
      const currentMemberIds = teamData?.data?.memberUserIds || [];
      const updatedMemberIds = currentMemberIds.filter(
        (id) => id !== activeUserForTeam.id,
      );

      // Prepare FormData for team update
      const formData = new FormData();
      Object.keys(teamData.data).forEach((key) => {
        if (key === "memberUserIds") {
          updatedMemberIds.forEach((userId) => {
            formData.append("memberUserIds", userId);
          });
        } else if (key === "trades" && Array.isArray(teamData.data[key])) {
          teamData.data[key].forEach((trade) => {
            formData.append("trades", trade);
          });
        } else if (
          key === "assignedZones" &&
          Array.isArray(teamData.data[key])
        ) {
          teamData.data[key].forEach((zone) => {
            formData.append("assignedZones", zone);
          });
        } else if (
          teamData.data[key] !== null &&
          teamData.data[key] !== undefined &&
          teamData.data[key] !== ""
        ) {
          formData.append(key, teamData.data[key]);
        }
      });

      await editTeam({ id: teamId, payload: formData }).unwrap();
      toast.success(trans("User unassigned from team successfully"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });
      await refetchTeams();
      setEdited();
    } catch (error) {
      toast.error(
        error?.data?.message || trans("Failed to unassign user from team"),
        {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar" ? true : false,
        },
      );
    }
  };

  useEffect(() => {
    if (!isAssigningTeam) {
      setSelectedTeams([]);
    }
  }, [isAssigningTeam]);

  const userName = userData?.data?.name || userData?.data?.email || "";

  return (
    <Popup show={isAssigningTeam} size="lg" style={"popup-bodyscroll"}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle headtitle={trans("Assign Teams")} subtitle={userName} />
        </Modal.Title>
        <Close
          style="close-32 close"
          close={() => {
            setIsAssigningTeam(false);
          }}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <div>
          <div className="mult-input-label">{trans("Teams")}</div>
          <Space
            style={{
              width: "100%",
            }}
            direction="vertical"
          >
            <Select
              mode="multiple"
              style={{
                width: "100%",
                marginTop: "8px",
              }}
              maxTagCount={"responsive"}
              placeholder={trans("Please select teams")}
              onSelect={(value) => {
                setSelectedTeams((prev) => [...prev, value]);
                handleAssign(value);
              }}
              onDeselect={(value) => {
                setSelectedTeams((prev) => prev.filter((v) => v !== value));
                handleUnAssign(value);
              }}
              value={selectedTeams}
              options={teams}
              open={isOpen}
              onDropdownVisibleChange={handleDropdownVisibleChange}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Space>
        </div>
      </Modal.Body>
    </Popup>
  );
}
